/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Remove_Attachment_Ids_InvalidInputs */

const es_co2_error_remove_attachment_ids_invalid = /** @type {(inputs: Error_Remove_Attachment_Ids_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uno de los archivos que intentas eliminar no existe en este registro.`)
};

/**

* @param {Error_Remove_Attachment_Ids_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_remove_attachment_ids_invalid = /** @type {((inputs?: Error_Remove_Attachment_Ids_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Remove_Attachment_Ids_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_remove_attachment_ids_invalid(inputs)
});